import axios from "axios";

export const Url = () => {
};


//Url.baseUrl='http://localhost:5216/api';

Url.baseUrl='https://apiquiz.mypossystem.in/api';